const make = $('#makeId');
const range = $('#rangeId');
const model = $('#modelId');

export const getFirstVehicleOption = (fieldname) => {
	return '<option value="">Choose ' + fieldname.replace('Id', '') + '</option>';
};

export const setVehicleOptions = (fieldname, optionList) => {
	var options = getFirstVehicleOption(fieldname);
	for (var i = 0; i < optionList.length; i++) {
		options += '<option value="' + optionList[i].value + '">' + optionList[i].label + '</option>';
	}

	return options;
};

export const disableVehicleSelect = (fieldname) => {
	$('#' + fieldname)
		.html(getFirstVehicleOption(fieldname))
		.attr("disabled", "disabled");
};

export const chainVehicleSelects = () => {
	make
		.on('change', function() {
			console.log($(this).val());

			if ($(this).val() != '') {
				var makeId = $(this).val();
				$.ajax({
					url: gs.ajaxServiceBase + 'getRangesJSON',
					dataType: "json",
					type: "POST",
					data: {
						makeId: makeId
					}
				})
				.done(function(result) {
					console.log(result);
					disableVehicleSelect('modelId');
					range
						.removeAttr("disabled")
						.html(setVehicleOptions('range', result))
						.focus()
						.on("change", function() {
							if ($(this).val() != '') {
								$.ajax({
									url: gs.ajaxServiceBase + 'getModelsJSON',
									dataType: "json",
									type: "POST",
									data: {
										rangeId: $("#rangeId").val()
									},
									success: function(result) {
										model
											.removeAttr("disabled")
											.html(setVehicleOptions('model', result))
											.focus()
											.on("change", function() {
												if ($(this).val() != '') {
													$(this).closest(".form-group").removeClass("has-error");
												}
											})
									}
								});
							}
						});
				})
				.fail(function(jqxhr, textStatus, error) {
					var displayError = "Error saving control center: " + textStatus + ", " + error;

					alert(displayError);
				});
			} else {
				disableVehicleSelect('rangeId');

				disableVehicleSelect('modelId');
			}
	});
};

if (make.length) {
	if (range.val() == "") {
		disableVehicleSelect('rangeId');
	}
	if (model.val() == "") {
		disableVehicleSelect('modelId');
	}

	chainVehicleSelects();

	$("#makeId, #rangeId, #modelId").on('focus', function() {
		$(this).closest(".form-group").removeClass("has-error");
	});

	$("#input_postcode").focus(function() {
		if (make.val() == '') {
			make.focus();
		} else if (range.val() == '') {
			range.focus();
		} else if (model.val() == '') {
			model.focus();
		}
	});
}